import LoadingOverlay from './loading-overlay';

export default LoadingOverlay;
